<template>
    <section class="bg-black-700 py-12 px-4 min-h-0">
        <div class="pb-8">
            <div class="phone:text-2xl text-2xl font-bold text-white tracking-widest uppercase tablet:-mt-3 text-center">
                {{ title }}
            </div>
        </div>
        <div class="grid gap-4 grid-cols-2 tablet:grid-cols-3 tabletLandscape:grid-cols-3 desktop:grid-cols-5">
            <a
                v-for="img in images"
                :key="img.id"
                href="javascript:void(0);"
                @click="open(img)">
                <gallery-image :image="img" />
            </a>
        </div>
        <comparison-lightbox
            v-if="image"
            :image="image"
            @close="close" />
    </section>
</template>

<script>
import GalleryImage from '@web/components/GalleryImage';
import ComparisonLightbox from '@web/components/ComparisonLightbox';

export default {
  components: {
    GalleryImage,
    ComparisonLightbox,
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      image: null,
    };
  },
  computed: {
    title() {
      return this.info.title;
    },
    images() {
      return this.info.images;
    },
  },
  methods: {
    open(image) {
      this.image = image;
    },
    close() {
      this.image = null;
    },
  },
};
</script>
